module.exports = __webpack_public_path__ + "img/6.9da29f90.png";